import { Colors, Language, Lightning, Router, Registry, VideoPlayer } from '@lightningjs/sdk'
import Button from '../components/buttons/Button'
import PlayButton from '../components/buttons/PlayButton'
import EpisodeCover from '../components/coverItems/EpisodeCover'
import LargeText from '../components/LargeText'
import { cleanHtml, formatDate } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'

export default class EpisodeDetail extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      EpisodeCover: { w: 580, h: 580, x: 360, y: 199, pivot: 0, type: EpisodeCover },
      InfoWrapper: {
        w: 800,
        h: 800,
        x: 1020,
        y: 199,
        Title: {
          w: 1125,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 62,
            fontFace: 'OpenSansBold',
            lineHeight: 65,
            wordWrapWidth: 800,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        ButtonWrapper: {
          w: 800,
          h: 80,
          pivot: 0,
          RewButton: {
            type: PlayButton,
            size: 80,
            buttonType: 'backward',
            icon: 'PlayerButtonBack',
          },
          PlayButton: {
            type: PlayButton,
            x: 100,
            size: 80,
            buttonType: 'playpause',
            icon: 'PlayerButtonPlay',
          },
          FwdButton: {
            type: PlayButton,
            x: 200,
            size: 80,
            buttonType: 'forward',
            icon: 'PlayerButtonForward',
          },
        },
        ByName: {
          w: 800,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('byName'),
            fontSize: 25,
            lineHeight: 40,
            fontFace: 'OpenSansLight',
          },
        },
        Start: {
          w: 800,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('start'),
            fontSize: 22,
            lineHeight: 40,
            fontFace: 'OpenSansLight',
          },
        },
        SubTitle: {
          w: 800,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('subtitle'),
            fontSize: 28,
            fontFace: 'OpenSansSemibold',
            lineHeight: 40,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        DescrWrapper: {
          w: 800,
          h: 85,
          DescrSmall: {
            w: 800,
            color: Colors('white').get(),
            alpha: 1,
            text: {
              text: this.bindProp('descrSmall'),
              fontSize: 28,
              lineHeight: 40,
              wordWrapWidth: 800,
              fontFace: 'OpenSansRegular',
              maxLines: 2,
              textOverflow: 'ellipsis',
            },
          },
          DescrLarge: { x: -40, w: 840, h: 270, alpha: 0.001, type: LargeText, clipbox: false },
        },
        Readmore: {
          w: 200,
          h: 60,
          type: Button,
          buttonText: Language.translate('Readmore'),
          padding: 5,
        },
      },
    }
  }

  set items(v) {
    this._item = v

    this.patch({
      title: this._item.podcast.title,
      byName: this._item.podcast.itunesAuthor,
      start: formatDate(new Date(this._item.pubDate), {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      }),
      subtitle: this._item.title,
      descrSmall: cleanHtml(this._item.description),
      EpisodeCover: { item: this._item.imageUrl },
    })
    this.tag('PlayButton').butnType =
      VideoPlayer.playing && VideoPlayer.src === this._item.streamUrl ? 'pause' : 'playpause'
    this.tag('DescrLarge').detailtext = cleanHtml(this._item.description)
  }

  set autoPlay(v) {
    this._autoPlay = v
  }

  pageTransition() {
    return 'fade'
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }

  _init() {
    this._descrCollaps = true

    this.widgets['sidemenu'].activeMenuItem = 3
    this.tag('Title').on('txLoaded', () => {
      this.tag('ButtonWrapper').y = this.tag('Title').y + this.tag('Title').finalH + 20
      this.tag('ByName').y = this.tag('Title').y + this.tag('Title').finalH + 125
    })
    this.tag('ByName').on('txLoaded', () => {
      this.tag('Start').y = this.tag('ByName').y + this.tag('ByName').finalH - 15
    })
    this.tag('Start').on('txLoaded', () => {
      this.tag('SubTitle').y = this.tag('Start').y + this.tag('Start').finalH + 15
    })
    this.tag('SubTitle').on('txLoaded', () => {
      this.tag('DescrWrapper').y = this.tag('SubTitle').y + this.tag('SubTitle').finalH - 10
      this.tag('Readmore').y = this.tag('SubTitle').y + this.tag('SubTitle').finalH + 95
    })
    this.tag('DescrSmall').on('txLoaded', () => {
      this.largeTextDims = this.tag('DescrLarge').dimensions
      this._showScroller = this.largeTextDims.height >= 285

      this.tag('Readmore').visible =
        this.tag('DescrSmall').finalH > 150 ||
        this.tag('DescrSmall').text.source.renderInfo.moreTextLines
    })

    this._setState('Idle')
  }

  _active() {
    this._setState('PlayButton')
  }
  OnGpStateChange({ playbuttonState }) {
    this.tag('PlayButton').OnGpStateChange({ playbuttonState })
  }
  _inactive() {
    this.stage.gc()
  }
  _seekTo(direction, duration = 0) {
    this._userIsSeeking = true
    this._seekTarget = Math.floor(VideoPlayer.currentTime)
    Registry.clearTimeout(this._seekTimeout)
    VideoPlayer.pause()

    if (duration) {
      this._seekTarget = duration
    } else {
      if (direction === 'left') {
        this._seekTarget -= 10
      } else {
        this._seekTarget += 30
      }
      const duration = Math.floor(VideoPlayer.duration)
      if (this._seekTarget <= 0) {
        this._seekTarget = 1
      } else if (this._seekTarget > duration - 1) {
        this._seekTarget = duration - 1
      }
    }

    this._seekTimeout = Registry.setTimeout(() => {
      VideoPlayer.seek(this._seekTarget)
      Registry.clearTimeout(this._seekTimeout)
    }, 300)
  }

  _startReadMore(show) {
    let duration = show === true ? 0.4 : 0.3,
      delay = show === true ? 0.1 : 0.2,
      episodeScale = show === true ? 0.5 : 1,
      infoWrapperX = show === true ? 700 : 1020,
      scrollerAlpha = show === true ? 1 : 0,
      moreButtonTxt =
        show === true ? Language.translate('Readless') : Language.translate('Readmore'),
      moreButtonTxty =
        show === true
          ? this.tag('DescrWrapper').y + 300
          : this.tag('SubTitle').y + this.tag('SubTitle').finalH + 95,
      descrWrapperH = show === true ? 285 : 94,
      descrSwitch = show === true ? 1 : 0

    if (this._showScroller === false) {
      scrollerAlpha = 0
    }
    this.tag('DescrLarge').setScrollerAlpha = scrollerAlpha

    this.patch({
      EpisodeCover: { smooth: { scale: [episodeScale, { delay: delay, duration: duration }] } },
      InfoWrapper: {
        smooth: { x: [infoWrapperX, { delay: delay, duration: duration }] },
        DescrWrapper: {
          smooth: { h: [descrWrapperH, { delay: delay, duration: duration }] },
          DescrLarge: { smooth: { alpha: [descrSwitch, { delay: delay, duration: duration }] } },
          DescrSmall: { smooth: { alpha: [!descrSwitch, { delay: delay, duration: duration }] } },
        },
        Readmore: {
          smooth: {
            buttonText: [moreButtonTxt, { delay: 0.3, duration: 0 }],
            y: [moreButtonTxty, { delay: 0.3, duration: duration }],
          },
        },
      },
    })

    this._descrCollaps = show !== true
  }
  _handlePlay() {
    let isSameStream = VideoPlayer.src === this._item.streamUrl
    if (!VideoPlayer.playing || VideoPlayer.src !== this._item.streamUrl) {
      this._setState('PlayButton')
      if (this.widgets['globalplayer'].playbuttonState === 'pause' && isSameStream) {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'play',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'podcast',
          listType: 'episode',
          item: this._item,
        })
      } else {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'startplay',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'podcast',
          listType: 'episode',
          item: this._item,
        })
      }
    }
  }

  _handlePause() {
    this.widgets.globalplayer.onPlayerUpdate({
      state: 'pause',
      list: [{ url: this._item.streamUrl }],
      startIndex: 0,
      type: 'podcast',
      listType: 'episode',
      item: this._item,
    })
    this._setState('PlayButton')
  }

  _handlePlayPause() {
    let isSameStream = VideoPlayer.src === this._item.streamUrl
    this._setState('PlayButton')
    if (VideoPlayer.playing && isSameStream) {
      this.widgets.globalplayer.onPlayerUpdate({
        state: 'pause',
        list: [{ url: this._item.streamUrl }],
        startIndex: 0,
        type: 'podcast',
        listType: 'episode',
        item: this._item,
      })
    } else {
      if (this.widgets['globalplayer'].playbuttonState === 'pause' && isSameStream) {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'play',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'podcast',
          listType: 'episode',
          item: this._item,
        })
      } else {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'startplay',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'podcast',
          listType: 'episode',
          item: this._item,
        })
      }
    }
  }

  _handleForward() {
    this._seekTo('right')
    this._setState('ForwardButton')
    // VideoPlayer.skip(30)
  }
  _handleRewind() {
    this._seekTo('left')
    this._setState('RewindButton')
    // VideoPlayer.skip(-10)
  }

  _handleStop() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
  }
  static _states() {
    return [
      class Idle extends this {},

      class PlayButton extends this {
        $enter() {
          this.tag('ButtonWrapper').setSmooth('scale', 1)

          if (
            VideoPlayer.playing &&
            appSettings &&
            appSettings.nowPlaying &&
            appSettings.nowPlaying.currentPlaying
          ) {
            if (appSettings.nowPlaying.currentPlaying.id === this._item.id) {
              this.tag('PlayButton').setState = 'play'
            }
          }

          if (this._autoPlay) {
            this._handlePlayPause()
            this._autoPlay = false
          }
        }

        _handleLeft() {
          this._setState('RewindButton')
        }

        _handleRight() {
          this._setState('ForwardButton')
        }

        _handleDown() {
          this._setState('MoreButton')
        }

        _handleEnter() {
          this._handlePlayPause()
        }

        _getFocused() {
          return this.tag('PlayButton')
        }
      },

      class ForwardButton extends this {
        _handleLeft() {
          this._setState('PlayButton')
        }

        _handleDown() {
          this._setState('MoreButton')
        }

        _handleEnter() {
          this._seekTo('right')
          // VideoPlayer.skip(30);
        }

        _getFocused() {
          return this.tag('FwdButton')
        }
      },

      class RewindButton extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleRight() {
          this._setState('PlayButton')
        }

        _handleDown() {
          this._setState('MoreButton')
        }

        _handleEnter() {
          this._seekTo('left')
          // VideoPlayer.skip(-10);
        }

        _getFocused() {
          return this.tag('RewButton')
        }
      },

      class MoreButton extends this {
        $enter() {
          this.tag('ButtonWrapper').setSmooth('scale', 0.75)
        }

        _handleLeft() {
          if (this._descrCollaps === false) {
            if (this._showScroller === true) {
              this._setState('DescrLarge')
            } else {
              Router.focusWidget('SideMenu')
            }
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleUp() {
          this._setState('PlayButton')
        }

        _handleEnter() {
          if (this._descrCollaps === true) {
            this._startReadMore(true)

            if (this._showScroller === true) {
              this._setState('DescrLarge')
            }
          } else {
            this._startReadMore(false)
          }
        }

        _getFocused() {
          return this.tag('Readmore')
        }
      },

      class DescrLarge extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleRight() {
          this._setState('MoreButton')
        }

        _getFocused() {
          return this.tag('DescrLarge')
        }
      },
    ]
  }
}
